const initGiftCardRecipientForm = () => {
  const wrapperEl = document.querySelector('[data-gift-card-recipient]');
  if (!wrapperEl) return;

  const toggleEl = wrapperEl.querySelector('[data-gift-card-recipient-toggle]');
  const fieldsEl = wrapperEl.querySelector('[data-gift-card-recipient-fields]');
  const inputEls = wrapperEl.querySelectorAll('[data-gift-card-recipient-input]');
  const requiredEls = wrapperEl.querySelectorAll('[data-gift-card-recipient-required]');
  if (!toggleEl || !fieldsEl) return;

  const setRecipientFieldsEnabled = (isEnabled) => {
    fieldsEl.classList.toggle('hidden', !isEnabled);
    fieldsEl.classList.toggle('flex', isEnabled);
    inputEls.forEach((inputEl) => {
      inputEl.disabled = !isEnabled;
    });
    requiredEls.forEach((requiredEl) => {
      requiredEl.required = isEnabled;
    });
  };

  toggleEl.addEventListener('change', () => {
    setRecipientFieldsEnabled(toggleEl.checked);
  });
};

export default initGiftCardRecipientForm;
